import { render, staticRenderFns } from "./politicsProjectFlow.vue?vue&type=template&id=74ff9753&scoped=true"
import script from "./politicsProjectFlow.vue?vue&type=script&lang=js"
export * from "./politicsProjectFlow.vue?vue&type=script&lang=js"
import style0 from "./politicsProjectFlow.vue?vue&type=style&index=0&id=74ff9753&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ff9753",
  null
  
)

export default component.exports